import manA1824PNG from '~/assets/images/anatomy/social-proof-anatomy-man-18-24.png'
import manA1824WEBP from '~/assets/images/anatomy/social-proof-anatomy-man-18-24.webp'
import manA2544PNG from '~/assets/images/anatomy/social-proof-anatomy-man-25-44.png'
import manA2544WEBP from '~/assets/images/anatomy/social-proof-anatomy-man-25-44.webp'
import manA4564PNG from '~/assets/images/anatomy/social-proof-anatomy-man-45-64.png'
import manA4564WEBP from '~/assets/images/anatomy/social-proof-anatomy-man-45-64.webp'
import manA65PlusPNG from '~/assets/images/anatomy/social-proof-anatomy-man-65-plus.png'
import manA65PlusWEBP from '~/assets/images/anatomy/social-proof-anatomy-man-65-plus.webp'
import womanA1824PNG from '~/assets/images/anatomy/social-proof-anatomy-woman-18-24.png'
import womanA1824WEBP from '~/assets/images/anatomy/social-proof-anatomy-woman-18-24.webp'
import womanA2544PNG from '~/assets/images/anatomy/social-proof-anatomy-woman-25-44.png'
import womanA2544WEBP from '~/assets/images/anatomy/social-proof-anatomy-woman-25-44.webp'
import womanA4564PNG from '~/assets/images/anatomy/social-proof-anatomy-woman-45-64.png'
import womanA4564WEBP from '~/assets/images/anatomy/social-proof-anatomy-woman-45-64.webp'
import womanA65PlusPNG from '~/assets/images/anatomy/social-proof-anatomy-woman-65-plus.png'
import womanA65PlusWEBP from '~/assets/images/anatomy/social-proof-anatomy-woman-65-plus.webp'
import { TImageVariant } from '~/pages/anatomy/libs/types'

export const SOCIAL_PROOF_IMAGE_VARIANTS: Record<string, TImageVariant> = {
  'female-18-24': { png: womanA1824PNG, webp: womanA1824WEBP },
  'female-25-44': { png: womanA2544PNG, webp: womanA2544WEBP },
  'female-45-64': { png: womanA4564PNG, webp: womanA4564WEBP },
  'female-65-plus': { png: womanA65PlusPNG, webp: womanA65PlusWEBP },
  'male-18-24': { png: manA1824PNG, webp: manA1824WEBP },
  'male-25-44': { png: manA2544PNG, webp: manA2544WEBP },
  'male-45-64': { png: manA4564PNG, webp: manA4564WEBP },
  'male-65-plus': { png: manA65PlusPNG, webp: manA65PlusWEBP },
}
